import { 
  Box,
  Skeleton,
  Grid,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useStudentActions } from "../../../hooks/useStudentActions";
import { useEffect, useState } from "react";
import LoadingSkeleton from "../../../components/loading-skeleton";
import { CollectionPreviewCard } from "./components/preview-card";
import AccessExpired from "../../../components/access-expired";

export default function Collections() {
  const { classroom_id } = useParams<{ classroom_id: string }>();
  

  const [loading, setLoading] = useState(false);

  const {
    classrooms, 
    getClassrooms,
    getCollections
  } = useStudentActions();

  const classroom = classrooms?.[Number(classroom_id)];

  useEffect(() => {
    const loadCollections = async () => {
      await getCollections(Number(classroom_id));
    };

    setLoading(true);
    if (classroom && !classroom.collections) loadCollections();
    setLoading(false);
  }, [classroom, classroom_id]);

  if (!classroom || !classroom.collections || loading) {
    return (<LoadingSkeleton/>);
  }

  if (classroom.expiry_date && new Date() >= new Date(classroom.expiry_date)) {
    return <AccessExpired classroom_id={classroom_id!}/>
  }

  const collectionList = Object.values(classroom.collections);
  
  return (
    <Box>
      {collectionList.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 6,
            color: "text.secondary",
          }}
        >
          <Typography variant="h6" fontWeight={500}>
            No collections available
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {collectionList
            .sort((a, b) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
            .map((collection) => (
              <Grid key={collection.id} size={{ xs: 12, md: 6, lg: 4 }}>
                <CollectionPreviewCard collection={collection}/>
              </Grid>
            ))}
        </Grid>
      )}
    </Box>
  );
}
